module.exports = __webpack_public_path__ + "img/opendoor4.04706a34.png";